module.exports = __webpack_public_path__ + "img/np_doug_arbor.jpg";